import * as FullStory from '@fullstory/browser';
import { valueOrNull } from '@whitelabel/helpers/utils';
import { CLAIM_JOURNEY_DATA, CLAIM_JOURNEY_ID } from './constants';
import { dateISOtoFullDateAndTime } from './date';
import { IBWClaimsJourneyTracking, IBWStoredClaimSelectorData, IBWClaimDetailsCommunicationsTracking } from './types';

export const bwClaimsJourneyTracking = ({
  claimJourneyID,
  bookingID,
  partner,
  policyName,
  claimSelectorName,
  decisionPointsName,
  decisionPointsAnswer,
  claimTypeName,
  sectionName,
  hasLeavedClaimJourney,
  hasSavedClaimData,
  completed,
  submitted,
  xclaimValidationError,
  fieldValidationErrorCount,
  hasClickedYourClaims,
  hasClickedHelpCenter,
}: IBWClaimsJourneyTracking): void => {
  if (!window.isHeadless && window.bwtag) {
    if (!claimJourneyID) {
      sessionStorage.setItem(
        CLAIM_JOURNEY_ID,
        JSON.stringify(`${bookingID}-${dateISOtoFullDateAndTime(new Date().toISOString())}`),
      );
    }

    const storedClaimSelectorData: IBWStoredClaimSelectorData =
      JSON.parse(localStorage.getItem(CLAIM_JOURNEY_DATA) as string) ?? {};
    const {
      policyName: storedPolicyName,
      claimSelectorName: storedClaimSelectorName,
      decisionPointsName: storedDecisionPointName,
      decisionPointsAnswer: storedDecisionPointsAnswer,
    } = storedClaimSelectorData;

    if (claimSelectorName && (policyName || (decisionPointsName && decisionPointsAnswer))) {
      localStorage.setItem(
        CLAIM_JOURNEY_DATA,
        JSON.stringify({
          claimSelectorName,
          policyName: policyName ?? valueOrNull(storedPolicyName),
          decisionPointsName,
          decisionPointsAnswer,
        }),
      );
    }

    window.bwtag('record', 'claims_journey', {
      claimJourneyID: claimJourneyID ?? JSON.parse(sessionStorage.getItem(CLAIM_JOURNEY_ID) as string),
      partner: valueOrNull(partner),
      policyName: policyName ?? valueOrNull(storedPolicyName),
      claimSelectorName: claimSelectorName ?? valueOrNull(storedClaimSelectorName),
      decisionPointsName: decisionPointsName ?? valueOrNull(storedDecisionPointName),
      decisionPointsAnswer: decisionPointsAnswer ?? valueOrNull(storedDecisionPointsAnswer),
      claimTypeName: valueOrNull(claimTypeName),
      sectionName: valueOrNull(sectionName),
      hasLeavedClaimJourney: hasLeavedClaimJourney ?? false,
      hasSavedClaimData: hasSavedClaimData ?? false,
      completed: completed ?? false,
      submitted: submitted ?? false,
      hasClickedYourClaims: hasClickedYourClaims ?? false,
      hasClickedHelpCenter: hasClickedHelpCenter ?? false,
      xclaimValidationError: valueOrNull(xclaimValidationError),
      fieldValidationErrorCount: fieldValidationErrorCount ?? 0,
      fsSession: FullStory.getCurrentSessionURL(true) ?? 'NA',
      bookingID,
    });
  }
};

export const bwClaimDetailsCommunicationsTracking = ({
  bookingID,
  claimReference,
  status,
  dateSent,
  link,
  linkText,
}: IBWClaimDetailsCommunicationsTracking): void => {
  if (!window.isHeadless && window.bwtag) {
    window.bwtag('record', 'claim_communications', {
      bookingID,
      claimReference,
      status,
      dateSent,
      link,
      linkText,
      fsSession: FullStory.isInitialized() ? FullStory.getCurrentSessionURL(true) : 'FS Not Ready',
    });
  }
};
